module.exports = __webpack_public_path__ + "static/img/end.8ef92731.jpg";